import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from '@material-ui/icons/Close';
import cn from 'classnames';
import { makeStyles, createStyles } from '../../styles';
import { buttonReset } from '../../mixins';
export const PaperModalClose = ({ className, onClick, }) => {
    const classes = useStyles();
    return (_jsxs("button", Object.assign({ className: cn(classes.root, className), onClick: onClick }, { children: ["Close", _jsx(CloseIcon, {})] })));
};
const useStyles = makeStyles((theme) => createStyles({
    root: Object.assign(Object.assign({}, buttonReset()), { display: 'flex', flexDirection: 'row', alignItems: 'center', fontWeight: 600, lineHeight: 1.11, letterSpacing: 1.42, textTransform: 'uppercase', fontSize: theme.fontSizes.xxs, padding: theme.spacing(0.75, 4), paddingBottom: 0, color: theme.palette.text.secondary, opacity: 0.5, '&:hover, &:focus': {
            opacity: 1,
        }, '& svg': {
            fontSize: 20,
        }, [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1),
        } }),
}));
export default PaperModalClose;
//# sourceMappingURL=PaperModalClose.js.map